import createIcon from '../../createIcon';

/**
 * @component @name SportsMotorsports
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAyIDExLjM4ODlDMTIuMDAyIDEwLjczODkgMTEuNjEyIDEwLjE1ODkgMTEuMDIyIDkuOTA4ODhMNS40NDE5NSA3LjU0ODg4QzMuOTYxOTUgOS4yMjg4OCAzLjEyMTk1IDExLjI0ODkgMi42NDE5NSAxMi45OTg5SDEwLjM5MkMxMS4yODIgMTIuOTk4OSAxMi4wMDIgMTIuMjc4OSAxMi4wMDIgMTEuMzg4OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS45NjIgMTEuMjE4OUMyMS41NTIgNi44MDg4OCAxNy40MDIgMy43Mjg4OCAxMi45ODIgNC4wMTg4OEMxMC40NzIgNC4xNzg4OCA4LjU0MTk1IDQuOTU4ODggNy4wNTE5NSA2LjA1ODg4TDExLjc5MiA4LjA2ODg4QzEzLjEyMiA4LjYzODg4IDEzLjk5MiA5LjkzODg4IDEzLjk5MiAxMS4zODg5QzEzLjk5MiAxMy4zNzg5IDEyLjM3MiAxNC45OTg5IDEwLjM4MiAxNC45OTg5SDIuMjExOTVDMi4wMDE5NSAxNi4zMDg5IDIuMDAxOTUgMTcuMTk4OSAyLjAwMTk1IDE3LjE5ODlWMTcuOTk4OUMyLjAwMTk1IDE5LjA5ODkgMi45MDE5NSAxOS45OTg5IDQuMDAxOTUgMTkuOTk4OUgxNC4wMDJDMTguNjcyIDE5Ljk5ODkgMjIuNDEyIDE1Ljk4ODkgMjEuOTYyIDExLjIxODlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsMotorsports = createIcon('SportsMotorsports', [
  [
    'path',
    {
      d: 'M12.002 11.3889C12.002 10.7389 11.612 10.1589 11.022 9.90888L5.44195 7.54888C3.96195 9.22888 3.12195 11.2489 2.64195 12.9989H10.392C11.282 12.9989 12.002 12.2789 12.002 11.3889Z',
      key: '1hc63d',
    },
  ],
  [
    'path',
    {
      d: 'M21.962 11.2189C21.552 6.80888 17.402 3.72888 12.982 4.01888C10.472 4.17888 8.54195 4.95888 7.05195 6.05888L11.792 8.06888C13.122 8.63888 13.992 9.93888 13.992 11.3889C13.992 13.3789 12.372 14.9989 10.382 14.9989H2.21195C2.00195 16.3089 2.00195 17.1989 2.00195 17.1989V17.9989C2.00195 19.0989 2.90195 19.9989 4.00195 19.9989H14.002C18.672 19.9989 22.412 15.9889 21.962 11.2189Z',
      key: '1u59gr',
    },
  ],
]);

export default SportsMotorsports;
